<template lang="pug">
erp-view(
  id="GestionUsuario"
  ref="GestionUsuario"
  title="Gestión Usuario"
  :blank="blank"
  :hide-header-title="blank"
)
  // ───────── HEADER ACTIONS ─────────
  template(slot="header-action") 
    // Botones según pestaña activa
    dx-button(v-if="tabIndex === 0" text="Guardar Datos" type="success" icon="fa fa-save" @click="guardarDatos")
    dx-button(v-if="tabIndex === 1 || tabIndex === 2 || tabIndex === 3" text="Clonar Roles y Permisos" type="normal" icon="fa fa-clone" @click="abrirPopupClonacion")
    dx-button(v-if="modelo.usuarioClonarId > 0" text="Limpiar Clonado" type="default" icon="fa fa-broom" @click="limpiarClonacion" ) 

    // 🔹 Texto informativo alineado a la derecha
    div(v-if="modelo.usuarioClonarId > 0" class="info-clonado")
      i.fas.fa-user-shield
      |  Clonando roles y permisos desde:
      span.nombre-origen {{ nombreUsuarioClonado?.nombresCompletos || '' }} 
  // ───────── CONTENIDO ─────────
  template(slot="content")


    dx-tab-panel(
      :selected-index.sync="tabIndex"
      :animation-enabled="true"
      :loop="false"
      :defer-rendering="true"
      :swipe-enabled="false"
      height="auto"   ✅
    )
      // TAB 1 - DATOS GENERALES
      dx-item(title="Datos Generales")
        template(#default)
          DatosGeneralesTab(:modelo.sync="modelo" :listas="listas")

      // TAB 2 - ROLES DBO 
      dx-item(title="Roles DBO")
        template(#default)
          RolesDboTab(:modelo.sync="modelo"  :listas="listas"   @roles-dbo-actualizados="cargarRolesDbo")

      // TAB 3 - ROLES SEGURIDAD
      dx-item( title="Roles Seguridad")
        template(#default)
          RolesSeguridadTab(:modelo.sync="modelo" :listas="listas" @roles-seguridad-actualizados="cargarRoleoSeguridad" )

      // TAB 4 - ACCESOS INDIVIDUALES
      dx-item(  title="Accesos Individuales")
        template(#default)
          AccesosIndividualesTab(:modelo.sync="modelo" :listas="listas" @accesosIndividuales-seguridad-actualizados="cargarAccesosIndividuales" )
 
    // ===== POPUP CLONACIÓN =====
    dx-popup(
      :visible.sync="popupClonacionVisible"
      title="Clonar Roles y Permisos"
      :width="400"
      :height="200"
      :show-close-button="true"
      :drag-enabled="true"
      :close-on-outside-click="true")   
      .popup-contenido
        .popup-header
          i.fas.fa-user-shield
          span.ml-2 Seleccione un usuario origen para clonar sus roles y permisos.
            dx-select-box.mt-3(
              :data-source="usuariosDisponibles"
              display-expr="nombresCompletos"
              value-expr="id"
              v-model="modelo.usuarioClonarId"
              :search-enabled="true"
              placeholder="🔍 Buscar usuario..."
              width="100%"
            )
            dx-button.mt-4(
              text="Clonar Roles y Permisos"
              type="success"
              icon="fa fa-check"
              width="100%"
              :disabled="!modelo.usuarioClonarId"
              @click="clonarDesdeOtroUsuario"
            )
</template>

<script>

import RolesDboTab from "./tabs/RolesDboTab.vue";
import RolesSeguridadTab from "./tabs/RolesSeguridadTab.vue";
import AccesosIndividualesTab from "./tabs/AccesosIndividualesTab.vue";
import DatosGeneralesTab from "./tabs/DatosGeneralesTab.vue";
import controlUsuarioResource from "@/api/ControlUsuarioResource.js";

export default {
  name: "GestionUsuario",
  components: {
    DatosGeneralesTab,
    RolesDboTab,
    RolesSeguridadTab,
    AccesosIndividualesTab
  },
  props: {
    blank: { type: Boolean, default: false },
    modo: { type: String, default: "crear" },
    data: { type: Object, default: null }
  },
  data() {
    return {
      tabIndex: 0,
      popupClonacionVisible: false,
      usuariosDisponibles: [
        { id: 1, nombre: "Carlos Díaz (cdiaz)" },
        { id: 2, nombre: "Rosa Flores (rflores)" },
        { id: 3, nombre: "Juan Pérez (jperez)" }
      ],
      nombreUsuarioClonado:{},
      modelo: {
        id: 0,
        tipoVinculacion: null,
        usuarioRed: "",
        codigoUsuario: "",
        nombreCompleto: "",
        documento: "",
        correo: "",
        cargoId: "",
        codigoSap: "",
        requiereReembolsos: false,
        centrosCostos: [], 
        usuarioClonarId: 0,
        clonarDesdeOtro: false,
        usuarioRedOrigen: ""
      },
      listas: {
        tiposVinculacion: [
          { nombre: "EMPLEADO", valor: "empleado" },
          { nombre: "SW COLOMBIA", valor: "swcolombia" },
          { nombre: "GENERICO", valor: "generico" }
        ],
        centrosCostos: [],
        cargos: [],
        // esquema dbo
        rolesDboClonados: [],
        rolesDboAsignados: [],
        rolesDboDisponibles: [],
        opcionesHabilitados: [],

        // esquema seguridad
        rolesSeguridadClonados: [],
        rolesSeguridadAsignados: [],
        rolesSeguridadDisponibles: [],
        rolesSeguridadModulos: [],
        rolesSeguridadPermisos: [],

        //permisos individuales
        permisosClonados: [],
        permisosAsignados: [],
        permisosDisponibles: [],
        
        //procesos ETL individuales 
        procesosClonados: [],
        procesosAsignados: [],
        procesosDisponibles: [],
         

      }
    };
  },
  watch: {
    popupClonacionVisible(val) {
      if (val) {
        this.$nextTick(() => {
          const popup = this.$el.querySelector(".dx-popup");
          if (popup) popup.style.display = "block";
        });
      }
    }
  },
  methods: {
    cargarRolesDbo(usuarioId, usuarioClonarId) {

      this.listas.rolesDboClonados = []; 
      this.listas.rolesDboAsignados = []; 
      this.listas.rolesDboDisponibles = []; 
      this.listas.opcionesHabilitados = [];

      controlUsuarioResource
        .cargarRolesDbo(usuarioId,usuarioClonarId)
        .then(res => {
          this.listas.rolesDboClonados = res.data.rolesDboClonados; 
          this.listas.rolesDboAsignados = res.data.rolesDboAsignados;
          this.listas.rolesDboDisponibles = res.data.rolesDboDisponibles;
          this.listas.opcionesHabilitados = res.data.opcionesHabilitados;
        })
        .catch(err => {
          this.$msg.handleError(err, "Obtener lista roles"); 
        });

    },
    cargarRoleoSeguridad(usuarioId, usuarioClonarId) {
 
      this.listas.rolesSeguridadClonados = []; 
      this.listas.rolesSeguridadAsignados = []; 
      this.listas.rolesSeguridadDisponibles = [];  
      this.listas.rolesSeguridadModulos = [];  
      this.listas.rolesSeguridadPermisos = [];  

      controlUsuarioResource
        .cargarRolesSeguridad(usuarioId,usuarioClonarId)
        .then(res => {
          this.listas.rolesSeguridadClonados = res.data.rolesSeguridadClonados; 
          this.listas.rolesSeguridadAsignados = res.data.rolesSeguridadAsignados;
          this.listas.rolesSeguridadDisponibles = res.data.rolesSeguridadDisponibles; 
          this.listas.rolesSeguridadModulos = res.data.rolesSeguridadModulos; 
          this.listas.rolesSeguridadPermisos = res.data.rolesSeguridadPermisos; 
        })
        .catch(err => {
          this.$msg.handleError(err, "Obtener lista roles"); 
        });

    },
    cargarAccesosIndividuales(usuarioId, usuarioClonarId) {
 
      this.listas.permisosClonados = []; 
      this.listas.permisosAsignados = []; 
      this.listas.permisosDisponibles = [];  

      this.listas.procesosClonados = [];  
      this.listas.procesosAsignados = [];  
      this.listas.procesosDisponibles = [];  
 
      controlUsuarioResource
        .cargarAccesosIndividuales(usuarioId,usuarioClonarId)
        .then(res => {
          this.listas.permisosClonados = res.data.permisosClonados; 
          this.listas.permisosAsignados = res.data.permisosAsignados;
          this.listas.permisosDisponibles = res.data.permisosDisponibles; 

          this.listas.procesosClonados = res.data.procesosClonados; 
          this.listas.procesosAsignados = res.data.procesosAsignados; 
          this.listas.procesosDisponibles = res.data.procesosDisponibles; 
        })
        .catch(err => {
          this.$msg.handleError(err, "Obtener lista roles"); 
        });

    },

    abrirPopupClonacion() {
      controlUsuarioResource
        .cargarlistaUsuarios()
        .then(res => {
          this.usuariosDisponibles = res.data; 
          this.modelo.usuarioClonarId = null;
          this.popupClonacionVisible = true;
        })
        .catch(err => {
          this.$msg.handleError(err, "Obtener lista roles"); 
        });
 
    },
    limpiarClonacion(){ 
      this.modelo.usuarioClonarId = 0;
      
      this.cargarRolesDbo(this.modelo.id,this.modelo.usuarioClonarId); 
      this.cargarRoleoSeguridad(this.modelo.id,this.modelo.usuarioClonarId);
      this.cargarAccesosIndividuales(this.modelo.id,this.modelo.usuarioClonarId);
 
      this.$msg.success(`Se Limipian los Roles y permisos clonados`);
    }, 

    clonarDesdeOtroUsuario() { 
      
      this.nombreUsuarioClonado = this.usuariosDisponibles.find(u => u.id === this.modelo.usuarioClonarId);

      this.cargarRolesDbo(this.modelo.id,this.modelo.usuarioClonarId);  
      this.cargarRoleoSeguridad(this.modelo.id,this.modelo.usuarioClonarId); 
      this.cargarAccesosIndividuales(this.modelo.id,this.modelo.usuarioClonarId);

      this.popupClonacionVisible = false;

      this.$msg.success(`Roles y permisos clonados desde ${this.nombreUsuarioClonado.nombresCompletos}`);
    },

    cargarDatos() {
      this.$refs.GestionUsuario.wait(true);
      controlUsuarioResource
        .cargarDatosGenerales()
        .then(res => {
          this.listas.centrosCostos = res.data.centrosCostos;
          this.listas.cargos = res.data.cargos;
          this.$refs.GestionUsuario.wait(false);
        })
        .catch(err => {
          this.$msg.handleError(err, "Obtener listas");
          this.$refs.GestionUsuario.wait(false);
        });
    },

    init(id) {
        // DBO
        this.listas.rolesDboClonados = []; 
        this.listas.rolesDboAsignados = [];
        this.listas.rolesDboDisponibles = [];
        this.listas.opcionesHabilitados = [];
        // SEGURIDAD
        this.listas.rolesSeguridadClonados = []; 
        this.listas.rolesSeguridadAsignados = []; 
        this.listas.rolesSeguridadDisponibles = [];  
        this.listas.rolesSeguridadModulos = [];  
        this.listas.rolesSeguridadPermisos = [];  
        // INDIVIDUALES PERMISOS
        this.listas.permisosClonados = []; 
        this.listas.permisosAsignados = []; 
        this.listas.permisosDisponibles = [];  
        // INDIVIDUALES PROCESOS
        this.listas.procesosClonados = [];  
        this.listas.procesosAsignados = [];  
        this.listas.procesosDisponibles = [];  

        this.modelo.id = 0;
        this.modelo.tipoVinculacion = null;
        this.modelo.usuarioRed= "";
        this.modelo.codigoUsuario= "";
        this.modelo.nombreCompleto= "";
        this.modelo.documento="";
        this.modelo.correo= "";
        this.modelo.cargoId= "";
        this.modelo.codigoSap= "";
        this.modelo.requiereReembolsos= false;
        this.modelo.centrosCostos= [];  
        this.modelo.clonarDesdeOtro= false;
        this.modelo.usuarioRedOrigen= "";
        this.modelo.usuarioClonarId=0;
        this.tabIndex = 0;

      if (id > 0) {
        this.$refs.GestionUsuario.wait(true);
        controlUsuarioResource
          .obtenerUsuario(id)
          .then(res => {
            const d = res.data;
            Object.assign(this.modelo, {
              ...d,
              rolesDbo: d.rolesDbo || [],
              rolesSeguridad: d.rolesSeguridad || [],
              permisosIndividuales: d.permisosIndividuales || []
            }); 

            this.cargarRolesDbo(this.modelo.id,this.modelo.usuarioClonarId);  
            this.cargarRoleoSeguridad(this.modelo.id,this.modelo.usuarioClonarId);  
            this.cargarAccesosIndividuales(this.modelo.id,this.modelo.usuarioClonarId);
            this.$refs.GestionUsuario.wait(false);
            this.$msg.success("Datos del usuario cargados correctamente");
          })
          .catch(err => {
            this.$refs.GestionUsuario.wait(false);
            this.$msg.handleError(err, "Obtener usuario");
          });
      }
      this.cargarDatos();
    },

    guardarDatos() { 

      this.$refs.GestionUsuario.wait(true);
      controlUsuarioResource
        .guardarUsuario(this.modelo)
        .then(res => {
          Object.assign(this.modelo, res.data);
          this.$refs.GestionUsuario.wait(false);
          this.$msg.success("Datos generales guardados correctamente");
          this.tabIndex = 1;
        })
        .catch(err => {
          this.$refs.GestionUsuario.wait(false);
          this.$msg.handleError(err, "Guardando datos generales");
        });
    },

    guardarRoles(esquema) {
      const lista = esquema === "dbo" ? this.modelo.rolesDbo : this.modelo.rolesSeguridad;
      if (!lista.length)
        return this.$msg.warn(`Debe asignar al menos un rol al esquema ${esquema.toUpperCase()}`);
      this.$msg.success(`Roles del esquema ${esquema.toUpperCase()} guardados correctamente.`);
    },

    guardarAccesos() {
      this.$msg.success("Accesos individuales guardados correctamente.");
    }
  }
};
</script>

<style scoped>
.dx-tabpanel { background: #fff; }
.p-3 { padding: 16px; }
.text-sm { font-size: 14px; color: #374151; }
.mb-2 { margin-bottom: 8px; }
.mt-4 { margin-top: 16px; }

 /* 🎨 Diseño limpio y centrado para el popup */
.popup-contenido {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 14px;
  background: #f9fafb;
  border-radius: 6px;
  box-sizing: border-box;
}

/* Título / descripción dentro del popup */
.popup-header {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #374151;
  background: #eef2ff;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.popup-header i {
  color: #2563eb;
  font-size: 16px;
}

/* Espaciados */
.mt-3 {
  margin-top: 12px;
}
.mt-4 {
  margin-top: 18px;
}

/* Botón */
:deep(.dx-button-success) {
  background-color: #16a34a !important;
  border: none !important;
  font-weight: 600;
}
:deep(.dx-button-success:hover) {
  background-color: #15803d !important;
}
.info-clonado {
  margin-left: auto; /* empuja hacia la derecha */
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff7ed;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13.5px;
  font-weight: 500;
  color: #92400e;
}

.info-clonado i {
  color: #b45309;
  font-size: 15px;
}

.nombre-origen {
  font-weight: 700;
  color: #78350f;
  margin-left: 4px;
  text-transform: uppercase;
}
</style>
